/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

import {
  QueueServiceProperties,
  ServiceSetPropertiesOptionalParams,
  ServiceSetPropertiesResponse,
  ServiceGetPropertiesOptionalParams,
  ServiceGetPropertiesResponse,
  ServiceGetStatisticsOptionalParams,
  ServiceGetStatisticsResponse,
  KeyInfo,
  ServiceGetUserDelegationKeyOptionalParams,
  ServiceGetUserDelegationKeyResponse,
  ServiceListQueuesSegmentOptionalParams,
  ServiceListQueuesSegmentResponse,
} from "../models/index.js";

/** Interface representing a Service. */
export interface Service {
  /**
   * Sets properties for a storage account's Queue service endpoint, including properties for Storage
   * Analytics and CORS (Cross-Origin Resource Sharing) rules
   * @param properties The StorageService properties.
   * @param options The options parameters.
   */
  setProperties(
    properties: QueueServiceProperties,
    options?: ServiceSetPropertiesOptionalParams,
  ): Promise<ServiceSetPropertiesResponse>;
  /**
   * gets the properties of a storage account's Queue service, including properties for Storage Analytics
   * and CORS (Cross-Origin Resource Sharing) rules.
   * @param options The options parameters.
   */
  getProperties(
    options?: ServiceGetPropertiesOptionalParams,
  ): Promise<ServiceGetPropertiesResponse>;
  /**
   * Retrieves statistics related to replication for the Queue service. It is only available on the
   * secondary location endpoint when read-access geo-redundant replication is enabled for the storage
   * account.
   * @param options The options parameters.
   */
  getStatistics(
    options?: ServiceGetStatisticsOptionalParams,
  ): Promise<ServiceGetStatisticsResponse>;
  /**
   * Retrieves a user delegation key for the Queue service. This is only a valid operation when using
   * bearer token authentication.
   * @param keyInfo Key information
   * @param options The options parameters.
   */
  getUserDelegationKey(
    keyInfo: KeyInfo,
    options?: ServiceGetUserDelegationKeyOptionalParams,
  ): Promise<ServiceGetUserDelegationKeyResponse>;
  /**
   * The List Queues Segment operation returns a list of the queues under the specified account
   * @param options The options parameters.
   */
  listQueuesSegment(
    options?: ServiceListQueuesSegmentOptionalParams,
  ): Promise<ServiceListQueuesSegmentResponse>;
}
